import { bus } from "./index";
import axios from "axios";

const dummy = "****";

const cartRequest = function (action, token, obj) {
    // var dto = { action: action };

    // for (var attrname in obj) {
    //     dto[attrname] = obj[attrname];
    // }

    var payload = new URLSearchParams();
    payload.append("action", action);
    for (var key in obj) {
        if(typeof obj[key] === 'object') {
            for (var key2 in obj[key]) {
                payload.append(key + '[' + key2 + ']', obj[key][key2]);
            }
        } else {
            payload.append(key, obj[key]);
        }
    }

    var req = axios
        .post(window.location.href, payload, {
            headers: {
                Accept: "application/json, text/javascript",
                "X-CSRF-Token": token,
            },
        })
        .catch((error) => {
            // console.log("error", error);
            if (error.response) {
                // if (![500, 400, 404].includes(error.response.status)) {
                if (error.response.data.exception == "modules\\errors\\FrontEndException") {
                    bus.$emit("error", error.response.data.error);
                } else {
                    bus.$emit("error", "Oops, er is iets mis gegaan.\nProbeer je even opnieuw?");
                    console.log("error response", error.response);
                }
            } else if (error.request) {
                console.log("error request", error.request);
            } else {
                console.log("error", error.message);
            }
        });

    return req;
};

const updateCart = (token, data) => {
    return cartRequest("commerce/cart/update-cart", token, data);
};

const setShippingAddressSameAsBilling = (token, value) => {
    return cartRequest("commerce/cart/update-cart", token, {
        shippingAddressSameAsBilling: value,
    });
};

const updateAddressCountry = (token, addressId, country) => {
    if (!addressId) throw new Error("addressId cannot be empty.");
    return cartRequest("commerce/customer-addresses/save", token, {
        "address[id]": addressId,
        "address[countryId]": country,
    });
};

const updateAddress = (
    token,
    addressId,
    address1,
    zipCode,
    city,
    countryId,
    firstName,
    lastName,
    phone,
    businessTaxId,
    businessName
) => {
    if (!addressId) throw new Error("addressId cannot be empty.");
    var dto = {
        "address[id]": addressId,
        "address[firstName]": firstName,
        "address[lastName]": lastName,
        "address[address1]": address1,
        "address[zipCode]": zipCode,
        "address[city]": city,
        "address[countryId]": countryId,
    };

    if (phone != undefined) dto["address[phone]"] = phone;
    if (businessTaxId != undefined) dto["address[businessTaxId]"] = businessTaxId;
    if (businessName != undefined) dto["address[businessName]"] = businessName;

    return cartRequest("commerce/customer-addresses/save", token, dto);
};

const getCart = (token) => {
    return cartRequest("commerce/cart/get-cart", token, {});
};

const getCustomCart = async (token) => {
    var req = await axios.get("/cart-json");
    if (req.data.cart.errors) {
        Object.values(req.data.cart.errors).forEach((err) => {
            bus.$emit("error", err);
        });
    }

    return req;
};

const updateCoupon = (token, code) => {
    return cartRequest("commerce/cart/update-cart", token, {
        couponCode: code,
    });
};

const updateEmail = (token, email) => {
    return cartRequest("commerce/cart/update-cart", token, {
        email: email,
    });
};

const updateOrderWantsInvoice = (token, orderWantsInvoice) => {
    return cartRequest("commerce/cart/update-cart", token, {
        "fields[orderWantsInvoice]": orderWantsInvoice,
    });
};

const addToCart = (token, item, quantity, extras, metadata, remark, birthList) => {
    var dto = {
        purchasableId: item.id,
        extras: extras ? JSON.stringify(extras) : null,
        remark: remark,
        qty: quantity,
        metadata: metadata ? JSON.stringify(metadata) : null,
    };
    if (birthList) {
        dto.birthList = birthList;
    }

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
            'currencyCode': 'EUR',
            'items': [
                { 
                    'item_name': item.name,
                    'item_id': item.sku,
                    'item_brand': item.brand,
                    'item_category': item.category,
                    'price': item.price,
                    'quantity': quantity
                }
            ]
        }
    });

    return cartRequest("itspersonal-module/cart/add", token, dto);
};

const setQuantity = (token, lineItemId, quantity) => {
    return cartRequest("itspersonal-module/cart/set-quantity", token, {
        lineItemId: lineItemId,
        qty: quantity,
    });
};

const removeItem = (token, lineItem) => {
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        'event': 'remove_from_cart',
        'ecommerce': {
            'currency': 'EUR',
            'items': [{ //  removing a product to a shopping cart.
                'item_name': lineItem.title,
                'item_id': lineItem.sku,
                'item_brand': lineItem.brand,
                'item_category': lineItem.productCategoryTitle,
                'item_variant': lineItem.purchasableTitle,
                'price': lineItem.price,
                'quantity': lineItem.qty
            }]
        }
    });

    return cartRequest("itspersonal-module/cart/remove", token, {
        lineItemId: lineItem.id,
    });
};

const processErrors = (dto) => {
    if (dto.error) {
        var err = dto.error;
        var errors = dto.cart.errors;

        console.error(err, errors);
    }
};

const updateShippingMethod = (token, shippingMethod) => {
    return cartRequest("commerce/cart/update-cart", token, {
        shippingMethodHandle: shippingMethod,
    });
};

const updateCartAddresses = (token, billingAddressId, shippingAddressId) => {
    return cartRequest("commerce/cart/update-cart", token, {
        billingAddressId: billingAddressId,
        shippingAddressId: shippingAddressId,
    });
};

const addVoucher = (token, code) => {
    return cartRequest("gift-voucher/cart/add-code", token, {
        voucherCode: code
    });
};

const removeVoucher = (token, code) => {
    return cartRequest("gift-voucher/cart/remove-code", token, {
        voucherCode: code
    });
};

export {
    cartRequest,
    updateCart,
    updateAddressCountry,
    getCart,
    updateShippingMethod,
    processErrors,
    addToCart,
    setQuantity,
    updateCoupon,
    removeItem,
    getCustomCart,
    setShippingAddressSameAsBilling,
    updateAddress,
    updateEmail,
    updateOrderWantsInvoice,
    updateCartAddresses,
    addVoucher,
    removeVoucher
};
